import React from "react";
import "./ModalPopup.css"; // Import CSS for styling
import { Link } from "react-router-dom";
import { Compoicon } from "../constant/constant";
import IconWithRoundedBorder from "./borderCir/BoderCir";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faMobileScreen } from "@fortawesome/free-solid-svg-icons";
const CommonModalPopup = ({isOpen,closeModal,data}) => {


    function openDialpad(phoneNumber) {
        // Create a temporary "tel:" URL
        const telUrl = `tel:${phoneNumber}`;
      
        // Create a temporary anchor element
        const link = document.createElement('a');
        link.href = telUrl;
        link.style.display = 'none';
      
        // Append the link to the document
        document.body.appendChild(link);
      
        // Simulate a click on the link
        link.click();
      
        // Remove the temporary link
        document.body.removeChild(link);
      }

      
    if(data.content==='CHART_INFO'){
  return (
    <div>
      {isOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header modalHeader" >
              <h2 style={{fontSize:'large'}}> CHART INFO</h2>
              <button className="close-btn" onClick={closeModal}>
                &#x2715;
              </button>
            </div>
            <div className="modal_body" >
                <div className="all_bids">
                    
                <Link to={`/jodi_chart/${data.game_name}`} className="footer-icon"><div className="child_comp">Jodi Chart  <Compoicon/></div></Link>
                <Link to={`/pana_chart/${data.game_name}`} className="footer-icon"><div className="child_comp">Pana Chart  <Compoicon/></div></Link>
                </div>    
            </div>
          
          </div>
        </div>
      )}
    </div>
  );
}else if(data.content==='CONNECT_SUPPORT'){
    return (<div>
      {isOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header modalHeader" style={{justifyContent:'end'}} >
              <button className="close-btn" onClick={closeModal}>
                &#x2715;
              </button>
            </div>
            <div className="modal_body" >
                <div className="CONNECT_DIV">
                <div className="div_call">
                    <Link onClick={()=>openDialpad(`+91${data.phone}`)} className="CONNECT_ICON"><IconWithRoundedBorder boxColor={'#e0e0e0'} paddingBox={'16px'} outerColor={'white'} innerColor={'white'} FonCompo={<FontAwesomeIcon icon={faMobileScreen} size="2x" color="red"/>}/></Link>
                    <h3 style={{marginTop:'19%'}}>Call Now</h3>
                </div>
                <div className="div_whatsapp">
                <a target="_blank" href={`https://wa.me/+91${data.phone}?text=Hello !!`} className="CONNECT_ICON" ><IconWithRoundedBorder boxColor={'#e0e0e0'} paddingBox={'16px'} outerColor={'white'} innerColor={'white'} FonCompo={<FontAwesomeIcon icon={faWhatsapp} size="2x" color="green"/>}/></a>
                <h3 style={{marginTop:'19%'}}>whatsapp</h3>
                </div>
                </div>    
            </div>
          
          </div>
        </div>
      )}
    </div>);
}
};

export default CommonModalPopup;
